import { sendAnalytics } from './globals';

type Params = {} & AnalyticsProps;

export const sendButtonClickAnalytics = (
  ev: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  params: Params
) => {
  const { currentTarget } = ev;
  const {
    dataTestId,
    analyticsId = 'Button Click',
    analyticsSelectorId,
    analyticsParams = {},
  } = params;

  const innerText = currentTarget?.innerText;

  const path = document.location.pathname;

  const payload: IAnalyticsPayload = {
    path,
    testId: dataTestId,
    selectorId: analyticsSelectorId,
    innerText,
    ...analyticsParams,
  };

  sendAnalytics(analyticsId, payload);
};
